import { Injectable } from "@angular/core";
import { GUARANTEEGROUP } from "app/model/guaranteegroup.model";
import { SharedPdfService } from "app/services/shared/shared-pdf.service";

@Injectable()
export class GUARANTEEService {
  constructor(private sharedPdfService:SharedPdfService) {}

  generateGuaranteepartA(guaranteeGroup: GUARANTEEGROUP) {
    //console.log(guaranteeGroup);
    return {
      style: "tableExample",
      table: {
        widths: ["30%", "35%", "35%"],
        body: [
          [
            { text: "I/We (“Guarantor”):", style: "questions" },
            {
              colSpan: 2,
              text: "  " + guaranteeGroup.in_guarantor_name,
              italics: true
            },
            ""
          ],
          [
            { text: "Guarantor’s Street ", style: "questions" },
            {
              colSpan: 2,
              text:
                "  " +
                (typeof guaranteeGroup.in_guarantor_address1 == "undefined"
                  ? " "
                  : guaranteeGroup.in_guarantor_address1),
              italics: true
            },
            ""
          ]
        ]
      }
    };
  }

  web() {
    console.log(window.location.href.indexOf(".co.nz"));
    return window.location.href.indexOf(".co.nz");
    // return 1;
  }


  generateGuaranteepartB(guaranteeGroup: GUARANTEEGROUP) {
    return {
      style: "tableExample",
      table: {
        widths: ["50%", "50%"],
        body: [
          [
            { text: "Customer Name:", style: "questions" },
            { text: this.web()>0?"NZCN:":"ABN:", style: "questions" }
          ],
          [
            {
              text: "  " + guaranteeGroup.in_guarantee_cust_name,
              italics: true
            },
            { text: "  " + guaranteeGroup.in_guarantor_abn, italics: true }
          ],
          [{style: "questions",text:"Guarantor Name: "},{style: "questions",text: "Witness Name:"}],
          [
            { text: "  " + guaranteeGroup.in_guarantor_name, italics: true },
            { text: "  " + guaranteeGroup.in_witness_name, italics: true }
          ],
          [{style: "questions",text:"Guarantor Street:"}, {style: "questions",text:"Witness Street :"}],
          [
            {
              text:
                "  " +
                (typeof guaranteeGroup.in_guarantor_address1 == "undefined"
                  ? " "
                  : guaranteeGroup.in_guarantor_address1),
              italics: true
            },
            {
              text:
                "  " +
                (typeof guaranteeGroup.in_witness_address1 == "undefined"
                  ? " "
                  : guaranteeGroup.in_witness_address1),
              italics: true
            }
          ],
          // ["Guarantor Address 2:", "Witness Address 2:"],
          // [
          //   {
          //     text: "  " + guaranteeGroup.in_guarantor_address2,
          //     italics: true
          //   },
          //   { text: "  " + guaranteeGroup.in_witness_address2, italics: true }
          // ],
          // ["Guarantor Address 3:", "Witness Street:"],
          // [
          //   {
          //     text: "  " + guaranteeGroup.in_guarantor_address3,
          //     italics: true
          //   },
          //   { text: "  " + guaranteeGroup.in_witness_street, italics: true }
          // ],
          [{style: "questions",text:"Guarantor Suburb:"}, {style: "questions",text:"Witness Suburb:"}],
          [
            { text: "  " + guaranteeGroup.in_guarantor_suburb, italics: true },
            { text: "  " + guaranteeGroup.in_witness_suburb, italics: true }
          ],
          [{style: "questions",text:"Guarantor Postcode:"},{style: "questions",text: "Witness Country:"}],

          [
            {
              text: "  " + guaranteeGroup.in_guarantor_postcode,
              italics: true
            },
            {
              text:
                "  " +
                (typeof guaranteeGroup.in_witness_country == "undefined"
                  ? " "
                  : guaranteeGroup.in_witness_country),
              italics: true
            }
          ],
          [{style: "questions",text:"Guarantor Country:"}, {style: "questions",text:"Witness Postcode:"}],
          [
            {
              text:
                "  " +
                (typeof guaranteeGroup.in_guarantor_country == "undefined"
                  ? " "
                  : guaranteeGroup.in_guarantor_country),
              italics: true
            },
            { text: "  " + guaranteeGroup.in_witness_postcode, italics: true }
          ],
          [{style: "questions", text: "Guarantor Signature:" },  {style: "questions",text:"Witness Signature:"}],
          [
            {
              text: "  "
            },
            { text: "  ", italics: true }
          ],
          [{ text: "Date:(Guarantor):" ,style: "questions"},  {style: "questions",text:"Date:(witness):"}],
          [
            {
              text: "  " + this.sharedPdfService.dateformat(guaranteeGroup.in_guarantor_date),
              italics: true
            },
            {
              text: "  " + this.sharedPdfService.dateformat(guaranteeGroup.in_witness_date),
              italics: true
            }
          ]
        ]
      }
    };
  }


}



// WEBPACK FOOTER //
// ./src/app/services/pdf/guaranteepdf.generation.ts